var React = require('react');

function MicrosoftOpaque (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 1H1v10h10V1ZM13 11h10V1H13v10ZM11 13H1v10h10V13ZM13 23h10V13H13v10Z","fill":"#E8EFFF","fillOpacity":".7"}));
}

MicrosoftOpaque.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = MicrosoftOpaque;

MicrosoftOpaque.default = MicrosoftOpaque;
